import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import "./JoinScreen.css";
import Review from "../Assets/review.gif";
import { RiAccountBoxFill, RiStarFill, RiStarHalfFill } from "@remixicon/react";
import Plan from "../Assets/plan.webp";
import Quiz from "../Assets/quiz.webp";
import Workshop from "../Assets/workshop.webp";
import Students from "../Assets/students.jpg";
import Mission from "../Assets/mission-vector.webp";
import Faq from "../Assets/faq.webp";
import Popupbg from "../Assets/popupbg3.png";
import Popupbg1 from "../Assets/popupbg1.png";

const JoinScreen = ({ start, goToCourse }) => {
  const [hovered, setHovered] = useState("");
  const [activeIndex, setActiveIndex] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 10000);

    return () => clearTimeout(timer);
  }, []);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const container = {
    hidden: { opacity: 1 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
      },
    },
  };

  const fadeInUp = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  const boxVariants = {
    hidden: { opacity: 0, scale: 0.8, y: 50 },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  const workVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  return (
    <div className="home-container">
      {showPopup && (
        <div className="popup-overlay">
          <motion.div
            className="popup-content"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
          >
            <img src={Popupbg} className="popup-img1" alt="" />
            <img src={Popupbg1} className="popup-img2" alt="" />
            <h2>
              Struggling to finish your thesis, proposal, or review paper?
            </h2>
            <p>
              Take our quick 2-minute quiz to uncover a personalized plan
              designed to help you write smarter, faster, and better.
            </p>
            <div style={{ zIndex: "5" }}>
              <button
                onClick={() => {
                  setShowPopup(false); // Close popup
                  start(); // Trigger quiz
                }}
              >
                Take the Quiz Now!
              </button>
              <button className="close-btn" onClick={() => setShowPopup(false)}>
                Close
              </button>
            </div>
          </motion.div>
        </div>
      )}
      <div className="home">
        <motion.div
          className="home-up"
          variants={container}
          initial="hidden"
          animate="visible"
        >
          <motion.p variants={fadeInUp} className="present">
            Presenting....
          </motion.p>
          <motion.h1 variants={fadeInUp}>FastWrite</motion.h1>
          <motion.h2 variants={fadeInUp}>
            Transform Your Academic Research – Faster, Smarter, Better.
          </motion.h2>
          <motion.p variants={fadeInUp}>
            Ready to revolutionize your academic journey? Whether you're a
            Master's student or PhD candidate, <strong>FastWrite</strong> is
            here to show you how to dramatically accelerate your research and
            writing process with the power of AI and expert guidance. Imagine
            finishing your thesis, review paper, or proposal in{" "}
            <strong>half the time</strong> without sacrificing quality.
          </motion.p>
          <motion.p variants={fadeInUp} className="strong-p">
            <strong>
              It’s time to stop struggling and start writing smarter.
            </strong>
          </motion.p>
          <motion.p variants={fadeInUp}>
            Take our quiz now to discover a tailored plan that will completely
            change your academic trajectory. Unlock your research potential
            today.
          </motion.p>
        </motion.div>
        <div className="home-down">
          <motion.div
            className="box box1"
            variants={boxVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.7 }}
          >
            <h3>AI-Powered Research Assistant</h3>
            <p>
              With <strong>FastWrite</strong>, you have access to cutting-edge
              AI tools designed to help you structure, write, and refine your
              research. Imagine having an assistant who never sleeps, helping
              you generate ideas, organize your papers, and even suggest
              relevant literature.{" "}
              <strong>No more staring at blank pages.</strong> Let AI help you
              write <strong>faster and smarter,</strong> freeing you to focus on
              creativity and critical thinking.
            </p>
            <a href="">Save Time, Write Faster</a>
          </motion.div>
          <motion.div
            className="box box2"
            variants={boxVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.7 }}
          >
            <h3>Expert-Led Workshops</h3>
            <p>
              Join our <strong>5-day workshop</strong> designed specifically for
              graduate students. Our experts guide you through the research
              process, step by step. From crafting a compelling proposal to
              writing a winning thesis, you'll get personalized support to{" "}
              <strong>accelerate your work.</strong>{" "}
              <strong>FastWrite isn’t just another online course;</strong> it’s
              your secret weapon for conquering the academic world faster and
              more efficiently than ever before.
            </p>
            <a href="">Ace Research Process in 5 Days</a>
          </motion.div>
          <motion.div
            className="box box3"
            variants={boxVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.7 }}
          >
            <h3>Proven Results</h3>
            <p>
              We’ve helped hundreds of students{" "}
              <strong>finish their research 40% faster</strong> using the power
              of AI and expert advice. Whether you're writing a review paper or
              a dissertation, the results speak for themselves.
              <strong>Don’t take our word for it</strong>— take our quiz and see
              how we can help you achieve your goals in record time!
            </p>
            <a href="">Save Time, Write Faster</a>
          </motion.div>
        </div>
      </div>
      <div className="work-section">
        <h1>How It Works</h1>
        <div className="work-container">
          <div className="left">
            <motion.div
              className="work-box quiz work-content"
              variants={workVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.9 }}
              onMouseEnter={() => setHovered("quiz")}
              onMouseLeave={() => setHovered("")}
            >
              <h1>Take The Quiz</h1>
              <p>
                Start by taking our 2-minute quiz. In just a few questions,
                we’ll help you uncover the research strategy that suits your
                needs. Whether you’re looking to finish your thesis faster or
                streamline your proposal, we’ve got the plan for you.
              </p>
            </motion.div>
            <motion.div
              className="work-box work-img plan"
              variants={workVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.9 }}
              onMouseEnter={() => setHovered("plan")}
              onMouseLeave={() => setHovered("")}
            >
              <img src={Plan} alt="Work" />
            </motion.div>
            <motion.div
              className="work-box workshop work-content"
              variants={workVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.9 }}
              onMouseEnter={() => setHovered("workshop")}
              onMouseLeave={() => setHovered("")}
            >
              <h1>Join the Workshop</h1>
              <p>
                Sign up for our 5-day intensive workshop. FastWrite will guide
                you from start to finish, showing you how to leverage AI tools
                and expert advice to finish your research faster. Accelerate
                your career by learning strategies that set you apart from your
                peers.
              </p>
            </motion.div>
          </div>
          <div className="line">
            <div className={`circle ${hovered === "quiz" ? "highlight" : ""}`}>
              <h1>1</h1>
            </div>
            <div className={`circle ${hovered === "plan" ? "highlight" : ""}`}>
              <h1>2</h1>
            </div>
            <div
              className={`circle ${hovered === "workshop" ? "highlight" : ""}`}
            >
              <h1>3</h1>
            </div>
          </div>
          <div className="right">
            <motion.div
              className="work-box work-img quiz"
              variants={workVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.9 }}
              onMouseEnter={() => setHovered("quiz")}
              onMouseLeave={() => setHovered("")}
            >
              <img src={Quiz} alt="Work" />
            </motion.div>
            <motion.div
              className="work-box plan work-content"
              variants={workVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.9 }}
              onMouseEnter={() => setHovered("plan")}
              onMouseLeave={() => setHovered("")}
            >
              <h1>Unlock Your Personalized Plan</h1>
              <p>
                Once you complete the quiz, you’ll get a custom strategy
                designed specifically for your academic needs. It’s tailored to
                help you write and research faster, making your graduate
                experience a smooth and successful journey.
              </p>
            </motion.div>
            <motion.div
              className="work-box work-img workshop"
              variants={workVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.9 }}
              onMouseEnter={() => setHovered("workshop")}
              onMouseLeave={() => setHovered("")}
            >
              <img src={Workshop} alt="Work" />
            </motion.div>
          </div>
        </div>
      </div>
      <div className="review-section">
        <div className="review-container">
          <motion.div
            className="review-left"
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.7 }}
            transition={{ duration: 1, ease: "easeOut" }}
          >
            <h1>
              What are our students saying
              <span>
                <img src={Review} alt="Review-Gif" />
              </span>
            </h1>
            <div className="review-scroll">
              <div className="review-card">
                <h1>
                  <span>
                    <RiAccountBoxFill color="#3AAC2A" />
                  </span>
                  Jessica, PhD Candidate in Psychology
                </h1>
                <h3 className="stars">
                  <RiStarFill size={20} color="#F7C52A" />
                  <RiStarFill size={20} color="#F7C52A" />
                  <RiStarFill size={20} color="#F7C52A" />
                  <RiStarFill size={20} color="#F7C52A" />
                  <RiStarHalfFill size={20} color="#F7C52A" />
                </h3>
                <p>
                  "Start by taking our 2-minute quiz. In just a few questions,
                  we’ll help you uncover the research strategy that suits your
                  needs."
                </p>
              </div>
              <div className="review-card">
                <h1>
                  <span>
                    <RiAccountBoxFill color="#3AAC2A" />
                  </span>
                  Mark, Master’s Student in Engineering
                </h1>
                <h3 className="stars">
                  <RiStarFill size={20} color="#F7C52A" />
                  <RiStarFill size={20} color="#F7C52A" />
                  <RiStarFill size={20} color="#F7C52A" />
                  <RiStarFill size={20} color="#F7C52A" />
                  <RiStarFill size={20} color="#F7C52A" />
                </h3>
                <p>
                  "I never thought I could finish my thesis in time. FastWrite
                  not only helped me write faster but also taught me how to
                  write smarter. I’m now on track to finish 3 months ahead of
                  schedule!"
                </p>
              </div>
              <div className="review-card">
                <h1>
                  <span>
                    <RiAccountBoxFill color="#3AAC2A" />
                  </span>
                  Sarah, PhD Student in History
                </h1>
                <h3 className="stars">
                  <RiStarFill size={20} color="#F7C52A" />
                  <RiStarFill size={20} color="#F7C52A" />
                  <RiStarFill size={20} color="#F7C52A" />
                  <RiStarFill size={20} color="#F7C52A" />
                  <RiStarFill size={20} color="#F7C52A" />
                </h3>
                <p>
                  "I’ve been struggling with writing a review paper for weeks.
                  After using FastWrite, I completed it in just a few days. The
                  AI tools helped me organize my ideas and focus on the most
                  important parts of my research."
                </p>
              </div>
              <div className="review-card">
                <h1>
                  <span>
                    <RiAccountBoxFill color="#3AAC2A" />
                  </span>
                  Daniel, Master’s Student in Computer Science
                </h1>
                <h3 className="stars">
                  <RiStarFill size={20} color="#F7C52A" />
                  <RiStarFill size={20} color="#F7C52A" />
                  <RiStarFill size={20} color="#F7C52A" />
                  <RiStarFill size={20} color="#F7C52A" />
                  <RiStarFill size={20} color="#F7C52A" />
                </h3>
                <p>
                  "FastWrite gave me the structure and confidence I needed to
                  move from research to writing without getting overwhelmed. The
                  5-day workshop was an eye-opener, and I can now approach my
                  thesis with a clear strategy."
                </p>
              </div>
              <div className="review-card">
                <h1>
                  <span>
                    <RiAccountBoxFill color="#3AAC2A" />
                  </span>
                  Emily, PhD Candidate in Education
                </h1>
                <h3 className="stars">
                  <RiStarFill size={20} color="#F7C52A" />
                  <RiStarFill size={20} color="#F7C52A" />
                  <RiStarFill size={20} color="#F7C52A" />
                  <RiStarFill size={20} color="#F7C52A" />
                  <RiStarFill size={20} color="#F7C52A" />
                </h3>
                <p>
                  "What I loved about FastWrite was the practical approach. It
                  wasn’t just theory—it was real-world advice that helped me
                  finish my research faster without compromising quality. I’m
                  now ahead of schedule and feel much less stressed."
                </p>
              </div>
            </div>
          </motion.div>
          <motion.div
            className="review-right"
            initial={{ opacity: 0, x: 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.7 }}
            transition={{ duration: 1, ease: "easeOut" }}
          >
            <img src={Students} alt="Students" />
            <h1>Satisfied Students</h1>
            <p>
              Our goal is to bring happiness to our clients every day, ensuring
              they feel satisfied and valued in every interaction.
            </p>
            <div className="review-buttons">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  start();
                }}
              >
                Take The Quiz Now!
              </a>
              {/* <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  goToCourse();
                }}
              >
                Go To Course
              </a> */}
            </div>
          </motion.div>
        </div>
      </div>
      <div className="mission" id="mission">
        <motion.div
          className="mission-left"
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.7 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <h1>Our Mission</h1>
          <img src={Mission} alt="Mission" />
        </motion.div>
        <motion.div
          className="mission-right"
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.7 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <p>
            At <strong>FastWrite,</strong> we believe academic research doesn’t
            have to be a drawn-out, stressful process. Our mission is to empower
            Master’s and PhD students by providing tools and strategies that
            help them work smarter, not harder.
          </p>
          <p>
            We’re committed to helping you unlock your full potential as a
            researcher, allowing you to finish your thesis or proposal faster
            and with more confidence.
            <strong>
              {" "}
              FastWrite is your academic success partner, here to make your
              journey smoother, faster, and more rewarding.
            </strong>
          </p>
        </motion.div>
      </div>
      <div className="faq">
        <motion.div
          className="faq-left"
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.7 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          {[
            {
              question:
                "What makes FastWrite different from other academic workshops?",
              answer:
                "FastWrite combines AI-powered tools with personalized expert guidance. Unlike traditional workshops, we focus on using technology to accelerate your research process, helping you write faster while maintaining high-quality standards.",
            },
            {
              question: "How long does the workshop take?",
              answer:
                "Our workshop lasts 5 days and is designed to fit into your busy academic schedule. You’ll learn everything from writing a review paper to completing your thesis in record time.",
            },
            {
              question:
                "Can I take the quiz if I’m still at the beginning of my academic journey?",
              answer:
                "Absolutely! Whether you’re just starting your Master’s or are deep into your PhD, the quiz will give you a clear plan tailored to your current needs and academic stage.",
            },
            {
              question:
                "Will I be able to use the AI tools even after the workshop?",
              answer:
                "Yes, once you join the workshop, you’ll get access to all of our AI-powered tools, allowing you to continue using them throughout your academic journey.",
            },
            {
              question:
                "What if I don’t have much time to dedicate to the workshop?",
              answer:
                "The FastWrite workshop is designed to be intensive but efficient. We’ve structured it so you can implement strategies quickly and start seeing results right away. In just 5 days, you’ll have a roadmap for completing your research faster",
            },
          ].map((item, index) => (
            <div key={index} className="faq-item">
              <h3 className="faq-question" onClick={() => toggleFAQ(index)}>
                {item.question}
              </h3>
              <p
                className={`faq-answer ${activeIndex === index ? "show" : ""}`}
              >
                {item.answer}
              </p>
            </div>
          ))}
        </motion.div>
        <motion.div
          className="faq-right"
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.7 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <h1>Frequently Asked Questions</h1>
          <img src={Faq} alt="Faq" />
        </motion.div>
      </div>
    </div>
  );
};

export default JoinScreen;
